var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.4 58.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00d1b7;}.cls-2{fill:#8c198f;}.cls-3{fill:#ff456e;}.cls-4{fill:#fc0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.7,24.56l-7.8,7.62a1.51,1.51,0,0,1-2.09,0L37.88,14.66a1.41,1.41,0,0,1,0-2L45.68,5a1.51,1.51,0,0,1,2.09,0L65.7,22.51A1.43,1.43,0,0,1,65.7,24.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.88,34.44l7.8,7.62a1.49,1.49,0,0,0,2.09,0L65.7,24.55a1.43,1.43,0,0,0,0-2.05l-7.8-7.62a1.51,1.51,0,0,0-2.09,0L37.88,32.4A1.41,1.41,0,0,0,37.88,34.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.48,35l7.8,7.62a1.51,1.51,0,0,0,2.09,0L39.3,25.05a1.41,1.41,0,0,0,0-2l-7.8-7.62a1.51,1.51,0,0,0-2.09,0L11.48,32.91A1.41,1.41,0,0,0,11.48,35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.3,44.83l-7.8,7.62a1.49,1.49,0,0,1-2.09,0L11.48,34.94a1.43,1.43,0,0,1,0-2l7.8-7.62a1.51,1.51,0,0,1,2.09,0L39.3,42.79A1.41,1.41,0,0,1,39.3,44.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/favIcon.122a3f5656dd6506a664aa6288822f46.svg";
export { ForwardRef as ReactComponent };